import { DUR } from '@/animations/settings/vars'
import { useStoreNavigation } from '@/store'
import { useRouter } from 'next/navigation'

const useNavigation = () => {
  const { setIsRouteTransition } = useStoreNavigation()

  const router = useRouter()

  const routeTransition = (e: React.MouseEvent, url: string) => {
    e.preventDefault()

    if (window.location.pathname === url) {
      return
    }
    if (window.location.pathname !== url.replace(/#.*$/, '')) {
      setIsRouteTransition(true)
    }

    setTimeout(() => {
      router.push(url as string)
    }, DUR.default * 1000)
  }

  return {
    routeTransition
  }
}

export default useNavigation
